<div class="main">
  <div class="container">
    <div class="header">
      <img src="../../../../../assets/images/logos/NanoH2O-Black@3x 1.png" alt="LG NanoH2O" class="center" height="40"
        width="380" />
    </div>
    <div style="background-color: rgb(255, 103, 39); height: 10px"></div>
    <form [formGroup]="ResetPassForm" (ngSubmit)="onSubmit()">
    
      <div class="m-2">
        <div class="row">
          <div class="col-10" style="text-align: left">
            <label style="font-weight: bolder;">Password Must Contain</label>
          </div>
        </div>

        <div class="row">
          <div class="col-1" style="text-align: left">
            <input type="checkbox" id="lowercaseCheck" disabled />
          </div>
          <div class="col-10" style="text-align: left">
            <label for="">One Lowercase</label>
          </div>
        </div>

        <div class="row">
          <div class="col-1" style="text-align: left">
            <input type="checkbox" id="uppercaseCheck" disabled />
          </div>
          <div class="col-10" style="text-align: left">
            <label for="">One Uppercase</label>
          </div>
        </div>

        <div class="row">
          <div class="col-1" style="text-align: left">
            <input type="checkbox" id="numberCheck" disabled />
          </div>
          <div class="col-10" style="text-align: left">
            <label for="">One Number</label>
          </div>
        </div>

        <div class="row">
          <div class="col-1" style="text-align: left">
            <input type="checkbox" id="specialCharCheck" disabled />
          </div>
          <div class="col-10" style="text-align: left">
            <label for="">One Special Character</label>
          </div>
        </div>

        <div class="row">
          <div class="col-1" style="text-align: left">
            <input type="checkbox" id="minLengthCheck" disabled />
          </div>
          <div class="col-10" style="text-align: left">
            <label for="">Minimum 7 Characters</label>
          </div>
        </div>


      </div>

      <input type="text" class="form-control border border-dark" name="password" placeholder="Password"
        formControlName="Password" aria-label="Password" (input)="validatePassword($event)" [ngClass]="{
          'is-invalid': submitted && ResetPassForm.controls.Password.errors
        }" aria-describedby="basic-addon1" />

      <div style="color: red; text-align: left;" *ngIf="containsUsername">
        Username cannot be part of the password.
      </div>
      <div style="color: red; text-align: left;" *ngIf="isCommonPassword">
        Common passwords like "password" are not allowed.
      </div>
      <div style="color: red; text-align: left;" *ngIf="containsConsecutiveNumbers">
        Password should not contain consecutive numbers.
      </div>
      <div style="color: red; text-align: left;" *ngIf="containsRepeatingChars">
        Password should not contain repeating characters.
      </div>

      <input type="text" class="form-control border border-dark" name="Confirm-password" placeholder="Confirm-Password"
        formControlName="ConfirmPassword" aria-label="Confirm-Password" aria-describedby="basic-addon1" />
      <br />
      <button type="submit">SUBMIT</button>
      <!-- <button type="button" onclick=""> </button> -->
    </form>
  </div>
</div>